module.exports = __webpack_public_path__ + "static/img/ratgeber.76bb7eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404_page/teaser/ratgeber.jpg
// module id = eTsm
// module chunks = 1